<lib-base-signal-input
  [label]="label()"
  [showRequired]="showRequiredIndicator()"
  [showError]="showError()"
  [errorMessage]="errorMessage()"
  [disabled]="disabled()"
  [showExternalLabel]="true"
>
  <div input class="w-full">
    @if (description()) {
      <p class="mb-3 text-xs text-slate-500">{{ description() }}</p>
    }
    <div
      class="w-full space-y-2 py-1"
      role="radiogroup"
      [attr.aria-label]="label()"
    >
      @for (option of options(); track option.value) {
        <button
          type="button"
          role="radio"
          [attr.aria-checked]="isSelected(option)"
          class="flex w-full items-center gap-4 rounded-lg border px-3 py-2.5 text-left transition-all duration-150"
          [class.cursor-pointer]="!isInteractionBlocked()"
          [class.cursor-default]="isInteractionBlocked()"
          [disabled]="disabled()"
          [attr.aria-disabled]="isInteractionBlocked() ? true : null"
          [class.border-blue-500]="isSelected(option)"
          [class.bg-blue-50]="isSelected(option)"
          [class.border-gray-300]="!isSelected(option)"
          [class.opacity-60]="disabled()"
          (click)="selectOption(option)"
        >
          <span
            class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2"
            [class.border-blue-500]="isSelected(option)"
            [class.border-gray-400]="!isSelected(option)"
          >
            @if (isSelected(option)) {
              <span class="h-2.5 w-2.5 rounded-full bg-blue-500"></span>
            }
          </span>

          <span class="min-w-0 flex-1">
            <span class="block text-sm font-semibold text-gray-900">
              {{ option.label }}
            </span>

            @if (option.description) {
              <span class="mt-0.5 block text-xs text-gray-500">
                {{ option.description }}
              </span>
            }
          </span>
        </button>
      }
    </div>
  </div>
</lib-base-signal-input>
